import React, { useCallback, useState, useEffect } from "react";
import BaseCard from "../components/BaseCard";
import styles from "./index.module.less";
import { RightOutlined } from "@/utils/antdIcon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import IconFont from "@/components/icon";

export default function NewAddedThirdapp (props: any) {
  const { service } = React.useContext<GlobalContextConfig>(GlobalContext);
  const { openNewPage } = props;
  const [data, setData] = useState<any>();
  useEffect(() => {
    service.appStoreService
      .getApplicationCountAndList({})
      .then((res) => {
        setData(res);
      })
      .catch((e) => {});
  }, []);
  const viewMore = useCallback(() => {
    openNewPage({
      openUrl: null,
      appKey: "",
      openApiType: -1,
      isNewThirdappAnalysis: true
    });
  }, []);
  return (
    <BaseCard>
      <div className={styles["new-added-thirdapp-wrap"]}>
        <div className={styles["header"]}>
          <div className={styles["content"]}>
            <IconFont
              type="iconic_pc_statistics"
              style={{ fontSize: "16px", marginRight: "5px" }}
            />
            <div className={styles["title"]}>近3个月新增</div>
            <div className={styles["num"]}>{data?.monthCount}</div>
            <div className={styles["title"]}>个，共</div>
            <div className={styles["num"]}>{data?.total}</div>
            <div className={styles["title"]}>个</div>
          </div>
          <div className={styles["more"]} onClick={viewMore}>
            <span className={styles["more-title"]}>
              {data?.applicationList?.slice(0, 3).map((app: any, index: number) => {
                return (
                  <img
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "2px",
                      borderRadius: "4px"
                    }}
                    key={index}
                    src={app.icon}
                  />
                );
              })}
            </span>
            <RightOutlined className={styles["more-icon"]} />
          </div>
        </div>
      </div>
    </BaseCard>
  );
}
